import { NavigationMenu } from './js/navigationMenu.js';
import { debounce } from './js/utils.js';

/**
 * Apply my base NavigationMenu to the menu + open the menu on desktop by default
 */
window.addEventListener("load", function () {
    const helpMenu = new NavigationMenu('.help-menu');

    function handleMenuState() {
        const isDesktop = window.innerWidth >= 782;

        helpMenu.menu.querySelectorAll('.menu-item-has-children').forEach(parentLi => {

            // open drop-down on desktop - close on mobile
            let trueOrFalse = isDesktop ? 'true' : 'false'; 
            parentLi.setAttribute('aria-expanded', trueOrFalse);

            // disable parent link click on desktop - restore on mobile
            const parentLink = parentLi.querySelector(':scope > a');
            if (parentLink) {
                if (isDesktop) {
                    parentLink.addEventListener('click', preventClick);
                    parentLink.style.pointerEvents = 'none'; // prevents clicking
                    parentLink.style.cursor = 'default'; // change cursor
                } else {
                    parentLink.removeEventListener('click', preventClick);
                    parentLink.style.pointerEvents = '';
                    parentLink.style.cursor = '';
                }
            }
        });
    }

    function preventClick(event) {
        event.preventDefault();
    }

    // Run on load
    handleMenuState();

    // Run on resize with debounce
    window.addEventListener('resize', debounce(handleMenuState, 300));
});